define('webshop',[
  'app',
  'require',
  'module',
  'marionette',
  'underscore',
  'windows',
  'itemPagesNameMixin',
  'contentShowController'
], function (
  App,
  require,
  module,
  Marionette,
  _,
  Windows,
  ItemPagesNameMixin,
  ContentShowController
) {
  'use strict';

  var WebshopRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'webshop': 'showProducts',
      'webshop/products': 'showProducts',
      'webshop/products/categories': 'showProductsCategories',
      'webshop/products/:id(/:tab)': 'showProduct',
      'webshop/categories': 'showCategories',
      'webshop/categories/tree': 'showCategoriesTree',
      'webshop/categories/:id(/:tab)': 'showCategory',
      'webshop/landingpages': 'showLandingpages',
      'webshop/landingpages/:id(/:tab)': 'showLandingpage',
      'webshop/filters': 'showFilters',
      'webshop/quotations(/:id)': 'showQuotations',
      'webshop/attributes(/:tab)': 'showAttributes',
      'webshop/menu(/:locale)': 'showMenu'
    }
  });

  var API = {
    showProducts: function () {
      require([
        'webshopProductsListView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          var view = new View({});

          App.currentUrl = App.getCurrentRoute();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_PRODUCTS);
        });
      });
    },

    showProductsCategories: function () {
      require([
        'webshopProductsCategoriesView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          var view = new View({});

          App.currentUrl = App.getCurrentRoute();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_PRODUCTS_CATEGORIES);
        });
      });
    },

    showProduct: function (id, tabName) {
      require([
        'webshopProductsDetailView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          View.prototype.open(id, tabName);
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_PRODUCTS, false);
        });
      });
    },

    showCategories: function (mode) {
      require([
        'webshopCategoriesListsView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          var view = new View({
            mode: mode ? mode : 'list'
          });

          App.currentUrl = App.getCurrentRoute();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_CATEGORIES);
        });
      });
    },

    showCategoriesTree: function () {
      API.showCategories('tree');
    },

    showCategory: function (id, tabName) {
      require([
        'webshopCategoriesDetailView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = 'webshop/categories';
          View.prototype.open(id, tabName);
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_CATEGORIES);
        });
      });
    },

    showLandingpages: function () {
      require([
        'webshopLandingpagesListView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          var view = new View({});

          App.currentUrl = App.getCurrentRoute();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_LANDINGPAGES);
        });
      });
    },

    showFilters: function () {
      require([
        'webshopFiltersView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = App.getCurrentRoute();
          App.regions.getRegion('main').currentView.getRegion('content').show(new View({}));
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_FILTERS);
        });
      });
    },

    showQuotations: function (id) {
      require([
        'webshopQuotationsView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = 'webshop/quotations';
          App.regions.getRegion('main').currentView.getRegion('content').show(new View({quotationId: id}));
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_QUOTATIONS);
        });
      });
    },

    // query: state of the tab (attribute, category, search, columns...), kept in the URL by the view
    showAttributes: function (tab, query) {
      require([
        'webshopAttributesView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = 'webshop/attributes';
          App.regions.getRegion('main').currentView.getRegion('content').show(new View({tab: tab, query: query}));
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_ATTRIBUTES);
        });
      });
    },

    showMenu: function (locale) {
      require([
        'webshopMenuView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = 'webshop/menu';
          App.regions.getRegion('main').currentView.getRegion('content').show(new View({locale: locale}));
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_MENU);
        });
      });
    },

    showLandingpage: function (id, tabName) {
      require([
        'webshopLandingpagesDetailView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = 'webshop/landingpages';
          View.prototype.open(id, tabName);
          App.execute('set:active:nav:item', ItemPagesNameMixin.WEBSHOP_LANDINGPAGES);
        });
      });
    }
  };

  App.on('before:start', function () {
    new WebshopRouter({
      controller: API
    });
  });

  module.exports = WebshopRouter;
});

